import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { workflowCardsData } from 'sections/Services/TradeFinance/data';
import { WorkflowCardType } from 'sections/Services/TradeFinance/types';
import styles from 'sections/Services/TradeFinance/components/SectionWorkflow/SectionWorkflow.module.scss';

const cn = classNames.bind(styles);

const SectionWorkflow = (): ReactElement => {
  const workflowCards = workflowCardsData.map((card: WorkflowCardType) => {
    return (
      <div className={cn('card')} key={card.id}>
        <h4 className={cn('card__heading')}>{card.heading}</h4>
        <p className={cn('card__description')}>{card.description}</p>
      </div>
    );
  });

  return (
    <section className={cn('workflow')}>
      <div className={cn('container')}>

        <h2 className={cn('workflow__heading')}>
          How it works?
        </h2>

        <div className={cn('workflow__cards')}>
          <picture className={cn('workflow__picture')}>
            <source
              srcSet="
                /images/pages/Services/TradeFinance/flow-mobile.webp 1x,
                /images/pages/Services/TradeFinance/flow-mobile@2x.webp 2x
              "
              sizes="100vw"
              media="(max-width: 768px)"
            />
            <source
              srcSet="
                /images/pages/Services/TradeFinance/flow-tablet.webp 1x,
                /images/pages/Services/TradeFinance/flow-tablet@2x.webp 2x
              "
              sizes="100vw"
              media="(max-width: 1200px)"
            />
            <source
              srcSet="
                /images/pages/Services/TradeFinance/flow-desktop.webp 1x,
                /images/pages/Services/TradeFinance/flow-desktop@2x.webp 2x
              "
              sizes="100vw"
            />
            <img
              className={cn('workflow__image')}
              src="/images/pages/Services/TradeFinance/flow-desktop.webp"
              alt="Flow"
            />
          </picture>
          {workflowCards}
        </div>

      </div>
    </section>
  );
};

export default SectionWorkflow;